import React, { Component } from "react";

class Control extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
    });
  }

  render() {
    if (this.state.loaded) {
      if (
        this.state.control.property.customUI ||
        this.state.control.property.control == "hidden"
      ) {
        return this.state.control.component;
      }

      return (
        <div className="form-group ">
          {this.state.control.property.label &&
          this.state.control.property.label != "" ? (
            <label style={{ fontWeight: "600" }} className="text-dark">
              {this.state.control.property.label}
            </label>
          ) : (
            ""
          )}
          <div>{this.state.control.component}</div>
          {this.state.control.property.help}
        </div>
      );
    } else {
      return "";
    }
  }
}

export default Control;
